export const NATIVE_CURRENCY_ADDRESS =
  "0x0000000000000000000000000000000000000000"
